export default __webpack_public_path__ + "images/c56db423b53051b6574af8aa945b83aa-physical-health.svg";